/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.1.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const STATISTICS_API_BASE_URL = new InjectionToken<string>('STATISTICS_API_BASE_URL');

@Injectable()
export class AppointmentsApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(STATISTICS_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stats(body: GetAppointmentStatsRequest | undefined) : Observable<GetAppointmentStatsResponse> {
        let url_ = this.baseUrl + "/api/stats/appointments/stats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStats(<any>response_);
                } catch (e) {
                    return <Observable<GetAppointmentStatsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAppointmentStatsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processStats(response: HttpResponseBase): Observable<GetAppointmentStatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAppointmentStatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAppointmentStatsResponse>(<any>null);
    }
}

@Injectable()
export class HealthApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(STATISTICS_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    probe() : Observable<void> {
        let url_ = this.baseUrl + "/api/stats/health/probe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProbe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProbe(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProbe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MobileApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(STATISTICS_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stats(body: GetMobileStatsRequest | undefined) : Observable<GetMobileStatsResponse> {
        let url_ = this.baseUrl + "/api/stats/mobile/stats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStats(<any>response_);
                } catch (e) {
                    return <Observable<GetMobileStatsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMobileStatsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processStats(response: HttpResponseBase): Observable<GetMobileStatsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMobileStatsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMobileStatsResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    installationHistory(body: GetMobileStatsRequest | undefined) : Observable<InstallationHistoryItem[]> {
        let url_ = this.baseUrl + "/api/stats/mobile/installation-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInstallationHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInstallationHistory(<any>response_);
                } catch (e) {
                    return <Observable<InstallationHistoryItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<InstallationHistoryItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processInstallationHistory(response: HttpResponseBase): Observable<InstallationHistoryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstallationHistoryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InstallationHistoryItem[]>([]);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mauHistory(body: GetMobileStatsRequest | undefined) : Observable<MonthlyActiveUsersHistoryItem[]> {
        let url_ = this.baseUrl + "/api/stats/mobile/mau-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMauHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMauHistory(<any>response_);
                } catch (e) {
                    return <Observable<MonthlyActiveUsersHistoryItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MonthlyActiveUsersHistoryItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processMauHistory(response: HttpResponseBase): Observable<MonthlyActiveUsersHistoryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyActiveUsersHistoryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyActiveUsersHistoryItem[]>([]);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    appOpened(body: AppOpenedRequest | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/api/stats/mobile/app-opened";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppOpened(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppOpened(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAppOpened(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PrescriptionApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(STATISTICS_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stats(body: GetPrescriptionsStatsRequest | undefined) : Observable<PrescriptionStatItem> {
        let url_ = this.baseUrl + "/api/stats/prescription/stats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStats(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionStatItem>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionStatItem>><any>_observableThrow(response_);
        }));
    }

    protected processStats(response: HttpResponseBase): Observable<PrescriptionStatItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionStatItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionStatItem>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    history(body: GetPrescriptionsStatsRequest | undefined) : Observable<PrescriptionHistoryItem[]> {
        let url_ = this.baseUrl + "/api/stats/prescription/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistory(<any>response_);
                } catch (e) {
                    return <Observable<PrescriptionHistoryItem[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PrescriptionHistoryItem[]>><any>_observableThrow(response_);
        }));
    }

    protected processHistory(response: HttpResponseBase): Observable<PrescriptionHistoryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrescriptionHistoryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PrescriptionHistoryItem[]>([]);
    }
}

@Injectable()
export class SessionApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(STATISTICS_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    inactive(body: GetInactiveTenantsRequest | undefined) : Observable<GetInactiveTenantsQueryResult> {
        let url_ = this.baseUrl + "/api/stats/session/inactive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInactive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInactive(<any>response_);
                } catch (e) {
                    return <Observable<GetInactiveTenantsQueryResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetInactiveTenantsQueryResult>><any>_observableThrow(response_);
        }));
    }

    protected processInactive(response: HttpResponseBase): Observable<GetInactiveTenantsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInactiveTenantsQueryResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetInactiveTenantsQueryResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportInactive(body: ExportInactiveTenantsRequest | undefined) : Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/stats/session/export-inactive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInactive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInactive(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExportInactive(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export class GetAppointmentStatsRequest implements IGetAppointmentStatsRequest {
    start!: Date;
    end!: Date;
    tenantId!: number | undefined;

    constructor(data?: IGetAppointmentStatsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): GetAppointmentStatsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentStatsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): GetAppointmentStatsRequest {
        const json = this.toJSON();
        let result = new GetAppointmentStatsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAppointmentStatsRequest {
    start: Date;
    end: Date;
    tenantId: number | undefined;
}

export class GetAppointmentStatsResponse implements IGetAppointmentStatsResponse {
    scheduledExecuted!: GetScheduledExecutedResult;
    serviceDuration!: GetServiceDurationResult;

    constructor(data?: IGetAppointmentStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduledExecuted = _data["scheduledExecuted"] ? GetScheduledExecutedResult.fromJS(_data["scheduledExecuted"]) : <any>undefined;
            this.serviceDuration = _data["serviceDuration"] ? GetServiceDurationResult.fromJS(_data["serviceDuration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppointmentStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduledExecuted"] = this.scheduledExecuted ? this.scheduledExecuted.toJSON() : <any>undefined;
        data["serviceDuration"] = this.serviceDuration ? this.serviceDuration.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetAppointmentStatsResponse {
        const json = this.toJSON();
        let result = new GetAppointmentStatsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAppointmentStatsResponse {
    scheduledExecuted: GetScheduledExecutedResult;
    serviceDuration: GetServiceDurationResult;
}

export class AppOpenedRequest implements IAppOpenedRequest {
    id!: string | undefined;
    tenantId!: number;
    originPlatform!: OriginPlatform;

    constructor(data?: IAppOpenedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.originPlatform = _data["originPlatform"];
        }
    }

    static fromJS(data: any): AppOpenedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AppOpenedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["originPlatform"] = this.originPlatform;
        return data; 
    }

    clone(): AppOpenedRequest {
        const json = this.toJSON();
        let result = new AppOpenedRequest();
        result.init(json);
        return result;
    }
}

export interface IAppOpenedRequest {
    id: string | undefined;
    tenantId: number;
    originPlatform: OriginPlatform;
}

export class GetMobileStatsRequest implements IGetMobileStatsRequest {
    start!: Date;
    end!: Date;
    tenantId!: number | undefined;

    constructor(data?: IGetMobileStatsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): GetMobileStatsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMobileStatsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): GetMobileStatsRequest {
        const json = this.toJSON();
        let result = new GetMobileStatsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetMobileStatsRequest {
    start: Date;
    end: Date;
    tenantId: number | undefined;
}

export class GetMobileStatsResponse implements IGetMobileStatsResponse {
    installations!: PieSeries[] | undefined;
    monthlyActiveUsers!: PieSeries[] | undefined;

    constructor(data?: IGetMobileStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["installations"])) {
                this.installations = [] as any;
                for (let item of _data["installations"])
                    this.installations!.push(PieSeries.fromJS(item));
            }
            if (Array.isArray(_data["monthlyActiveUsers"])) {
                this.monthlyActiveUsers = [] as any;
                for (let item of _data["monthlyActiveUsers"])
                    this.monthlyActiveUsers!.push(PieSeries.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMobileStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMobileStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.installations)) {
            data["installations"] = [];
            for (let item of this.installations)
                data["installations"].push(item.toJSON());
        }
        if (Array.isArray(this.monthlyActiveUsers)) {
            data["monthlyActiveUsers"] = [];
            for (let item of this.monthlyActiveUsers)
                data["monthlyActiveUsers"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetMobileStatsResponse {
        const json = this.toJSON();
        let result = new GetMobileStatsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMobileStatsResponse {
    installations: PieSeries[] | undefined;
    monthlyActiveUsers: PieSeries[] | undefined;
}

export class GetPrescriptionsStatsRequest implements IGetPrescriptionsStatsRequest {
    start!: Date;
    end!: Date;
    tenantId!: number | undefined;

    constructor(data?: IGetPrescriptionsStatsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): GetPrescriptionsStatsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrescriptionsStatsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): GetPrescriptionsStatsRequest {
        const json = this.toJSON();
        let result = new GetPrescriptionsStatsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPrescriptionsStatsRequest {
    start: Date;
    end: Date;
    tenantId: number | undefined;
}

export class ExportInactiveTenantsRequest implements IExportInactiveTenantsRequest {
    periodRange!: PeriodRange;

    constructor(data?: IExportInactiveTenantsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodRange = _data["periodRange"] ? PeriodRange.fromJS(_data["periodRange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExportInactiveTenantsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportInactiveTenantsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodRange"] = this.periodRange ? this.periodRange.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ExportInactiveTenantsRequest {
        const json = this.toJSON();
        let result = new ExportInactiveTenantsRequest();
        result.init(json);
        return result;
    }
}

export interface IExportInactiveTenantsRequest {
    periodRange: PeriodRange;
}

export class GetInactiveTenantsRequest implements IGetInactiveTenantsRequest {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    periodRange!: PeriodRange;

    constructor(data?: IGetInactiveTenantsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.periodRange = _data["periodRange"] ? PeriodRange.fromJS(_data["periodRange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInactiveTenantsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetInactiveTenantsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["periodRange"] = this.periodRange ? this.periodRange.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetInactiveTenantsRequest {
        const json = this.toJSON();
        let result = new GetInactiveTenantsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetInactiveTenantsRequest {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    periodRange: PeriodRange;
}

export class GetScheduledExecutedResult implements IGetScheduledExecutedResult {
    total!: ScheduledExecutedItem;
    inPerson!: ScheduledExecutedItem;
    inPersonPrivate!: ScheduledExecutedItem;
    inPersonInsurance!: ScheduledExecutedItem;
    remotely!: ScheduledExecutedItem;
    remotelyPrivate!: ScheduledExecutedItem;
    remotelyInsurance!: ScheduledExecutedItem;

    constructor(data?: IGetScheduledExecutedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"] ? ScheduledExecutedItem.fromJS(_data["total"]) : <any>undefined;
            this.inPerson = _data["inPerson"] ? ScheduledExecutedItem.fromJS(_data["inPerson"]) : <any>undefined;
            this.inPersonPrivate = _data["inPersonPrivate"] ? ScheduledExecutedItem.fromJS(_data["inPersonPrivate"]) : <any>undefined;
            this.inPersonInsurance = _data["inPersonInsurance"] ? ScheduledExecutedItem.fromJS(_data["inPersonInsurance"]) : <any>undefined;
            this.remotely = _data["remotely"] ? ScheduledExecutedItem.fromJS(_data["remotely"]) : <any>undefined;
            this.remotelyPrivate = _data["remotelyPrivate"] ? ScheduledExecutedItem.fromJS(_data["remotelyPrivate"]) : <any>undefined;
            this.remotelyInsurance = _data["remotelyInsurance"] ? ScheduledExecutedItem.fromJS(_data["remotelyInsurance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetScheduledExecutedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetScheduledExecutedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        data["inPerson"] = this.inPerson ? this.inPerson.toJSON() : <any>undefined;
        data["inPersonPrivate"] = this.inPersonPrivate ? this.inPersonPrivate.toJSON() : <any>undefined;
        data["inPersonInsurance"] = this.inPersonInsurance ? this.inPersonInsurance.toJSON() : <any>undefined;
        data["remotely"] = this.remotely ? this.remotely.toJSON() : <any>undefined;
        data["remotelyPrivate"] = this.remotelyPrivate ? this.remotelyPrivate.toJSON() : <any>undefined;
        data["remotelyInsurance"] = this.remotelyInsurance ? this.remotelyInsurance.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetScheduledExecutedResult {
        const json = this.toJSON();
        let result = new GetScheduledExecutedResult();
        result.init(json);
        return result;
    }
}

export interface IGetScheduledExecutedResult {
    total: ScheduledExecutedItem;
    inPerson: ScheduledExecutedItem;
    inPersonPrivate: ScheduledExecutedItem;
    inPersonInsurance: ScheduledExecutedItem;
    remotely: ScheduledExecutedItem;
    remotelyPrivate: ScheduledExecutedItem;
    remotelyInsurance: ScheduledExecutedItem;
}

export class ScheduledExecutedItem implements IScheduledExecutedItem {
    scheduled!: number;
    executed!: number;

    constructor(data?: IScheduledExecutedItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduled = _data["scheduled"];
            this.executed = _data["executed"];
        }
    }

    static fromJS(data: any): ScheduledExecutedItem {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledExecutedItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduled"] = this.scheduled;
        data["executed"] = this.executed;
        return data; 
    }

    clone(): ScheduledExecutedItem {
        const json = this.toJSON();
        let result = new ScheduledExecutedItem();
        result.init(json);
        return result;
    }
}

export interface IScheduledExecutedItem {
    scheduled: number;
    executed: number;
}

export class GetServiceDurationResult implements IGetServiceDurationResult {
    min!: number;
    max!: number;
    avg!: number;

    constructor(data?: IGetServiceDurationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.avg = _data["avg"];
        }
    }

    static fromJS(data: any): GetServiceDurationResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceDurationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["avg"] = this.avg;
        return data; 
    }

    clone(): GetServiceDurationResult {
        const json = this.toJSON();
        let result = new GetServiceDurationResult();
        result.init(json);
        return result;
    }
}

export interface IGetServiceDurationResult {
    min: number;
    max: number;
    avg: number;
}

export class InstallationHistoryItem implements IInstallationHistoryItem {
    date!: Date;
    google!: number;
    apple!: number;

    constructor(data?: IInstallationHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.google = _data["google"];
            this.apple = _data["apple"];
        }
    }

    static fromJS(data: any): InstallationHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new InstallationHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["google"] = this.google;
        data["apple"] = this.apple;
        return data; 
    }

    clone(): InstallationHistoryItem {
        const json = this.toJSON();
        let result = new InstallationHistoryItem();
        result.init(json);
        return result;
    }
}

export interface IInstallationHistoryItem {
    date: Date;
    google: number;
    apple: number;
}

export class MonthlyActiveUsersHistoryItem implements IMonthlyActiveUsersHistoryItem {
    date!: Date;
    google!: number;
    apple!: number;
    pwa!: number;
    site!: number;

    constructor(data?: IMonthlyActiveUsersHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.google = _data["google"];
            this.apple = _data["apple"];
            this.pwa = _data["pwa"];
            this.site = _data["site"];
        }
    }

    static fromJS(data: any): MonthlyActiveUsersHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyActiveUsersHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["google"] = this.google;
        data["apple"] = this.apple;
        data["pwa"] = this.pwa;
        data["site"] = this.site;
        return data; 
    }

    clone(): MonthlyActiveUsersHistoryItem {
        const json = this.toJSON();
        let result = new MonthlyActiveUsersHistoryItem();
        result.init(json);
        return result;
    }
}

export interface IMonthlyActiveUsersHistoryItem {
    date: Date;
    google: number;
    apple: number;
    pwa: number;
    site: number;
}

export class PieSeries implements IPieSeries {
    label!: string | undefined;
    value!: number;
    color!: string | undefined;

    constructor(data?: IPieSeries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): PieSeries {
        data = typeof data === 'object' ? data : {};
        let result = new PieSeries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["color"] = this.color;
        return data; 
    }

    clone(): PieSeries {
        const json = this.toJSON();
        let result = new PieSeries();
        result.init(json);
        return result;
    }
}

export interface IPieSeries {
    label: string | undefined;
    value: number;
    color: string | undefined;
}

export class PrescriptionHistoryItem implements IPrescriptionHistoryItem {
    date!: Date;
    smart!: number;
    standard!: number;

    constructor(data?: IPrescriptionHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.smart = _data["smart"];
            this.standard = _data["standard"];
        }
    }

    static fromJS(data: any): PrescriptionHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["smart"] = this.smart;
        data["standard"] = this.standard;
        return data; 
    }

    clone(): PrescriptionHistoryItem {
        const json = this.toJSON();
        let result = new PrescriptionHistoryItem();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionHistoryItem {
    date: Date;
    smart: number;
    standard: number;
}

export class PrescriptionStatItem implements IPrescriptionStatItem {
    smart!: number;
    standard!: number;

    constructor(data?: IPrescriptionStatItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smart = _data["smart"];
            this.standard = _data["standard"];
        }
    }

    static fromJS(data: any): PrescriptionStatItem {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionStatItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smart"] = this.smart;
        data["standard"] = this.standard;
        return data; 
    }

    clone(): PrescriptionStatItem {
        const json = this.toJSON();
        let result = new PrescriptionStatItem();
        result.init(json);
        return result;
    }
}

export interface IPrescriptionStatItem {
    smart: number;
    standard: number;
}

export class GetInactiveTenantsQueryResult implements IGetInactiveTenantsQueryResult {
    readonly totalCount!: number;
    readonly items!: TenantLastActive[] | undefined;

    constructor(data?: IGetInactiveTenantsQueryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(TenantLastActive.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInactiveTenantsQueryResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetInactiveTenantsQueryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetInactiveTenantsQueryResult {
        const json = this.toJSON();
        let result = new GetInactiveTenantsQueryResult();
        result.init(json);
        return result;
    }
}

export interface IGetInactiveTenantsQueryResult {
    totalCount: number;
    items: TenantLastActive[] | undefined;
}

export class TenantLastActive implements ITenantLastActive {
    id!: number;
    name!: string | undefined;
    email!: string | undefined;
    phoneNumber!: string | undefined;
    lastAccess!: Date;

    constructor(data?: ITenantLastActive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.lastAccess = _data["lastAccess"] ? new Date(_data["lastAccess"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantLastActive {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLastActive();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["lastAccess"] = this.lastAccess ? this.lastAccess.toISOString() : <any>undefined;
        return data; 
    }

    clone(): TenantLastActive {
        const json = this.toJSON();
        let result = new TenantLastActive();
        result.init(json);
        return result;
    }
}

export interface ITenantLastActive {
    id: number;
    name: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    lastAccess: Date;
}

export enum OriginPlatform {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class PeriodRange implements IPeriodRange {
    from!: Date;
    to!: Date;

    constructor(data?: IPeriodRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PeriodRange {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }

    clone(): PeriodRange {
        const json = this.toJSON();
        let result = new PeriodRange();
        result.init(json);
        return result;
    }
}

export interface IPeriodRange {
    from: Date;
    to: Date;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}